export default __webpack_public_path__ + "static/media/tt.f3b1780e.svg";